<form #fillOrjoinCandidateForm="ngForm" novalidate>
    <div class="form-group wrap-text-in">
        <label class="modal-body-font-size ng-scope">
            <span class="updateReqtextcolor">'{{job.currentStateName}}' </span>the
            Requisition
            <span class="updateReqtextcolor "> '{{job.Role}}' </span>
            <span *ngIf="job.Company">for
                <span class="updateReqtextcolor">'{{job.Company}}'</span></span>
        </label> 
        <p *ngIf="job.currentStateName === 'Join'">
            The Job Match status for all the other jobs that the candidate is on will be set to <br>'<span
                class="emerald">Not Interested</span>'.
        </p>
        <p>Are you sure you want to continue?</p>
    </div>

    <div class="form-group">
        <div class="row">
            <div class="col-xs-6"
                [ngClass]="{'has-error': fillOrjoinCandidateForm.submitted && fromDate.invalid}">
                <label for="currentDate">Date</label>
                <div class="input-group">
                    <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                    </span>
                    <input #fromDate="ngModel" type="text" class="form-control" placeholder="mm-dd-yyyy" name="currentDate"
                        [(ngModel)]="job.date" [disabled]="true" required>
                </div>
                <div class="error error-gap" *ngIf="fillOrjoinCandidateForm.submitted && fromDate.invalid">
                    <small class="ng-hide"><em>*</em>
                        Date is required</small>
                </div>
            </div>

            <div class="col-xs-6" [ngClass]="{'has-error':(fillOrjoinCandidateForm.submitted && time.invalid)}">
                <label for="time">Time</label>
                <div class="input-group">
                    <span class="input-group-addon">
                        <i class="far fa-clock"></i>
                    </span>
                    <input #time="ngModel" type="text" class="form-control" placeholder="hh:mm:ss" [(ngModel)]="job.time" 
                        name="time" [disabled]="true" required>
                </div>
                <div class="error error-gap ng-hide" *ngIf="fillOrjoinCandidateForm.submitted && time.invalid">
                    <small class="ng-hide"><em>*</em>Time is required </small>
                </div>
            </div>
        </div>
    </div>

    <div class="form-group" style="margin-bottom:0px" *ngIf="job.currentStateName == 'Fill'">
        <div class="row">
            <div class="col-xs-12">
                <div class="checkbox-nice">
                    <input type="checkbox" id="fillException" name="fillException" [(ngModel)]="isFillException"
                        #fillException="ngModel" (change)="onCandidateSelectionExceptionChange()" />
                    <label for="fillException">
                        Exception
                    </label>
                </div>
                <p class="text-danger" style="font-size: 13px;">
                    Note: By selecting this option, you acknowledge that the candidate being selected to <b>Fill</b> might have gone through the last step in the process <b>outside</b> of the regular candidate workflow.
                </p>
            </div>
        </div>
    </div>

    <div class="form-group">
        <div class="row">
            <div class="col-xs-6"
                [ngClass]="{'has-error':fillOrjoinCandidateForm.submitted && !job.candidate}">
                <label for="interviewCompletedCandidate">Candidate<em> * </em>
                    <span class="text-danger" style="font-size: 12px;">
                        (All the other Job Matches that the candidate is currently on will be set to 'Not Interested'.)
                    </span>
                </label>
                <div class="well" *ngIf="candidates.length == 0">
                    <span class="text-danger">No candidates are available who have completed the workflow.</span>
                </div>
                <select id="interviewCompletedCandidate" name="interviewCompletedCandidate" *ngIf="candidates.length > 0"
                    class="form-control btn btn-secondary inputBoxBorder dropdown-toggle" [(ngModel)]="job.candidate"
                    (change)="onCandidateChange()" required>
                    <option *ngFor="let t of candidates" [ngValue]="t">
                        {{ t.name }}
                    </option>
                </select>
                <div class="error error-gap ng-hide" *ngIf="fillOrjoinCandidateForm.submitted && !job.candidate">
                    <small class=""><em>*</em>Please select a candidate</small>
                </div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-xs-12" *ngIf="job.currentStateName == 'Fill'">
                <div class="col-xs-4">
                    <div class="form-group" [ngClass]="{'has-error':(fillOrjoinCandidateForm.submitted && fillDate.invalid)}">
                        <label for="fillDate" class="control-label">
                            Fill Date <em> * </em>: 
                        </label>
                        <div class="input-group">
                            <div class="input-group-addon">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <input #fillDate="ngModel" type="text" id="fillDate" name="fillDate" class="form-control" [(ngModel)]="job.fillDateDisplayValue"
                                [disabled]="!job.candidate" (change)="onFillDateChange()" required>
                        </div>
                    </div>
                </div>
                <div class="col-xs-4">
                    <div class="form-group">
                        <label for="expectedJoinDate" class="control-label">
                            Expected Join Date:
                        </label>
                        <div class="input-group">
                            <div class="input-group-addon">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <input #expectedJoinDate="ngModel" type="text" id="expectedJoinDate" name="expectedJoinDate" class="form-control"
                                [disabled]="!job.candidate" [(ngModel)]="job.expectedJoinDateDisplayValue"
                                (change)="onExpectedJoinDateChange()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12" *ngIf="job.currentStateName == 'Join'">
                <div class="col-xs-4">
                    <div class="form-group" [ngClass]="{'has-error':fillOrjoinCandidateForm.submitted && joinDate.invalid}">
                        <label for="joinDate" class="control-label">
                            Join Date <em> * </em>: 
                        </label>
                        <div class="input-group">
                            <div class="input-group-addon">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <input #joinDate="ngModel" type="text" id="joinDate" name="joinDate" class="form-control" [disabled]="!job.candidate"
                                [(ngModel)]="job.joinDateDisplayValue" (change)="onJoinDateChange()" required>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xs-12" *ngIf="jobMatchesWhoseStatusCanBeSetArray.length>0">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Req #</th>
                    <th>Title</th>
                    <th>Recruiters</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let jobMatch of jobMatchesWhoseStatusCanBeSetArray">
                    <td>{{jobMatch.requisitionNumber}}</td>
                    <td>{{jobMatch.requisitionTitle}}</td>
                    <td>{{jobMatch.recruitersMessage}}</td>
                    <td>
                        <span [innerHTML]="jobMatch.message"></span>
            
                        <span *ngIf="jobMatch.meetingInfoArray.length > 0" class="pointer red fa fa-info-circle"
                            [popover]="jobMatchStatusPopoverTemplate" [popoverTitle]="jobMatch.meetingsPopOverTitle"
                            placement="bottom" container="body" triggers="mouseenter:mouseleave" [popoverContext]="{jobMatch: jobMatch}"
                            [isOpen]="jobMatch.meetingDetailsPopoverIsOpenFlag">
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="form-group"
        [ngClass]="{'has-error':(fillOrjoinCandidateForm.submitted && note.invalid)}">
        <label>Notes <em> * </em></label>
        <div>
            <!-- Voice Input -->
            <div class="mb-2">
                <app-voice-input 
                    (transcriptReady)="onVoiceTranscript($event)"
                    [sourceScreen]="sourceScreen"
                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                </app-voice-input>
            </div>
            <textarea #note="ngModel" name="note"
                class="form-control"
                style="height: 100px; width: 100%;resize: none;" maxlength="503" [(ngModel)]="job.note"
                required
                (change)="onInternalNoteChanged()">
            </textarea>
        </div>
        <div class="error error-gap ng-hide" *ngIf="fillOrjoinCandidateForm.submitted && note.invalid">
            <small class=""><em>*</em>Note is required</small>
        </div>
        <!-- Formalize Text -->
        <app-formalize-comment 
            [inputText]="job.note" 
            (outputText)="receiveFormalizedComment($event)"
            [sourceScreen]="sourceScreen"
            [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
            [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
            [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
            [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
        </app-formalize-comment>
    </div>
    <app-external-notes
        *ngIf="isSharedRequisition"
        [form]="fillOrjoinCandidateForm" [note]="job.note"
        [copyNote]="copyNote" [externalNote]="job.externalNote"
        (onExternalNoteChange)="onExternalNoteChange($event)"
        (onCopyNoteChange)="onCopyNoteChange($event)"
        [sourceScreen]="sourceScreen"
        [formalizeActivityPayload]="formalizeActivityPayload">
    </app-external-notes>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
        <button type="submit" (click)="save()" [disabled]="disableSubmit" class="btn btn-primary">Ok</button>
    </div>
</form>

<ng-template #jobMatchStatusPopoverTemplate let-jobMatch="jobMatch">
    <div>
        <div class="row">
            <div class="col-xs-12">
                <div class="row candidate-job-match-row">
                    <div class="col-xs-4 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        Scheduled Date
                    </div>
                    <div class="col-xs-3 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        Status
                    </div>
                    <div class="col-xs-5 set-job-match-status-meeting-details-header-text text-overflow-ellipsis">
                        {{ jobMatch.meetingUserLabel }}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="jobMatch.meetingInfoArray && jobMatch.meetingInfoArray.length > 0">
            <div class="col-xs-12" *ngFor="let meeting of jobMatch.meetingInfoArray">
                <div class="row set-job-match-status-meeting-details-meeting-row">
                    <div class="col-xs-4 text-overflow-ellipsis">
                        {{ meeting.startDateTime | fourDotFiveTimeStampFormatPipe }}
                    </div>
                    <div class="col-xs-3 text-overflow-ellipsis">
                        <span class="text-overflow-ellipsis">
                            {{ meeting.statusLabel }}
                        </span>
                        <span [ngClass]="meeting.statusClass"></span>
                    </div>
                    <div class="col-xs-5 text-overflow-ellipsis">
                        {{ meeting.userName }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>